import script from "./LDPipPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./LDPipPopover.vue?vue&type=script&setup=true&lang=js"

import "./LDPipPopover.vue?vue&type=style&index=0&id=853e5744&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-853e5744"]])

export default __exports__